<template>
  <div>
    Please insert the whitelisted addresses for claiming the NFT PASS or drop
    profile (
    <a class="text-secondary-7" :href="DOWNLOAD_URL">download template</a>) down
    below.

    <div
      class="rounded p-2 space-x-2 flex bg-white-005 my-3"
      style="width: fit-content"
    >
      <div
        class="
          px-6
          rounded
          flex
          items-center
          h-10
          transition-all
          cursor-pointer
          font-bold
        "
        v-for="(text, i) in ['Upload manually', 'Upload through file']"
        :style="`background:${
          i == state.whiteMode
            ? 'linear-gradient(315deg, #FF5585 0%, #268CFF 100%);'
            : ''
        }`"
        @click="state.whiteMode = i"
        :key="i"
      >
        {{ text }}
      </div>
    </div>

    <div v-if="state.whiteMode == 0">
      <div class="text-black text-sm mb-3 h-6">Address</div>
      <div class="space-y-3">
        <div
          class="relative"
          v-for="(item, i) in state.whitelist"
          :key="item.id"
        >
          <UiInput v-model="item.value" :rules="['address']"></UiInput>
          <div
            v-if="i != 0"
            class="absolute right-0 -top-2 cursor-pointer"
            @click="delWhite(i)"
          >
            <i class="iconfont icon-guanbi text-xs"></i>
          </div>
        </div>
      </div>

      <div
        class="mt-2 inline-table cursor-pointer"
        @click="state.whitelist.push({ id: uuid(), value: '' })"
      >
        <i class="iconfont icon-tianjia-46"></i>
      </div>
    </div>
    <UiUploadFile
      v-else
      :successName="fileName"
      :onUpload="uploadWhiteExcel"
      :onSuccess="onFileSuccess"
      :onDelete="onFileFailed"
    ></UiUploadFile>
  </div>
</template>

<script setup>
import {
  inject,
  reactive,
  watchEffect,
  defineProps,
  computed,
  onMounted,
  watch,
} from 'vue';
import { uuid } from '@/utils';
import UiUploadFile from '@/components/UiUploadFile.vue';
import UiInput from '@/components/UiInput.vue';
import UiTabs from '@/components/UiTabs.vue';
import { uploadWhiteExcel } from '@/api/common';
import { DOWNLOAD_URL } from '@/constants';

const formInfo = inject('formInfo');

// TODO 因为存在来回切换，所以这里文件的状态是必须要保存的
// TODO 成功的话状态会保留，但是失败的话会消失

const props = defineProps({
  passType: String,
});

const state = reactive({
  whiteMode: 0,
  whitelist: [{ id: uuid(), value: '' }],
});

const delWhite = (i) => {
  state.whitelist.splice(i, 1);
};

const fileName = computed(() => {
  if (props.passType == 'fixed_price') {
    return formInfo.passFixedPrice.fileName;
  }
  if (props.passType == 'staking_based') {
    return formInfo.passStakingBasedDTO.fileName;
  }
  return '';
});

watchEffect(() => {
  const list = state.whitelist.filter((x) => !!x.value).map((x) => x.value);

  if (props.passType == 'fixed_price') {
    formInfo.passFixedPrice.whiteList = list;
  }
  if (props.passType == 'staking_based') {
    formInfo.passStakingBasedDTO.whiteList = list;
  }
});

const onFileSuccess = (id, name) => {
  if (formInfo.passType == 'fixed_price') {
    formInfo.passFixedPrice.excelUuid = id;
    formInfo.passFixedPrice.fileName = name;
  }
  if (formInfo.passType == 'staking_based') {
    formInfo.passStakingBasedDTO.excelUuid = id;
    formInfo.passStakingBasedDTO.fileName = name;
  }
};

const onFileFailed = () => {
  if (formInfo.passType == 'fixed_price') {
    formInfo.passFixedPrice.excelUuid = null;
    formInfo.passFixedPrice.fileName = '';
  }
  if (formInfo.passType == 'staking_based') {
    formInfo.passStakingBasedDTO.excelUuid = null;
    formInfo.passStakingBasedDTO.fileName = '';
  }
};

onMounted(() => {
  state.whiteMode =
    formInfo.passType == 'fixed_price'
      ? formInfo.passFixedPrice.whiteMode
      : formInfo.passStakingBasedDTO.whiteMode;
});

watch(
  () => state.whiteMode,
  (status) => {
    if (formInfo.passType == 'fixed_price') {
      formInfo.passFixedPrice.whiteMode = status;
    } else {
      formInfo.passStakingBasedDTO.whiteMode = status;
    }
  },
);
</script>

<style lang="scss" scoped></style>
